'use strict';

var _ = require('lodash');

module.exports = class RuleComponent {
    /**
     * See parent for details.
     * @param  {Object[]} config The configuration to build with.
     */
    constructor(config) {
        validate(config);

        // false values will be evaluated again, once it evaluates to true it stops being checked
        this._evaluateState = false;
        this._componentAttributes = config.componentAttributes;
    }

    get componentAttributes() {
        return this._componentAttributes;
    }

    get evaluateState() {
        return this._evaluateState;
    }

    /**
     * Evalutes the current rule component based on the provided attributeSelection.
     *
     * @param  {Object} attributeSelection The attribute selection to evaluate.
     * @return {bool} true if and only if this attribute is valid through the evaluation of attributeSelection.
     */
    evaluate(attributeSelection) {
        let evaluationResults = [];

        _.each(this._componentAttributes, (componentAttribute) => {
            let evaluationResult = componentAttribute.evaluate(attributeSelection);
            evaluationResults.push(evaluationResult);
        });

        this._evaluateState = _.some(evaluationResults, {evaluateState: true});

        return {
            evaluateState: this._evaluateState,
            componentEvaluationResults: evaluationResults,
            shouldCalculationsBeExcluded: () => {
                return !this._evaluateState &&
                    _.every(evaluationResults, (componentResult) => !componentResult.evaluateState && _.isNil(componentResult.formula));
            }
        };
    }
};

function validate(config) {
    if (_.isNil(config)) {
        throw new Error('config must not be null or undefined.');
    }
}
